import React from 'react';
import client1 from '../images/clients/ne.png';
import client2 from '../images/clients/mickle.png';
import client3 from '../images/clients/nmw.png';
import client4 from '../images/clients/no.png';
import client5 from '../images/clients/proveda.png';
import client6 from '../images/clients/tbc.png';
import client7 from '../images/clients/tw.png';
import client8 from '../images/clients/sg.png';
import client9 from '../images/clients/harmony.png';

const clientImage = {
  height: '10rem',
  width: 'auto',
  mixBlendMode: 'colorBurn'
};

const Clients = () => {
  return (
    <div className="mt-8 bg-gray-100">
      <section data-aos="fade-up">
        <div className="my-4 py-4">
          <h2 className="my-2 text-center text-3xl text-blue-900 uppercase font-bold">Our Clients</h2>
          <div className='flex justify-center'>
            <div className='w-24 border-b-4 border-blue-900'></div>
          </div>
          <h2 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-blue-900">Some of our clients.</h2>
        </div>

        <div className="relative overflow-hidden group">
          <div className="whitespace-nowrap animate-scroll group-hover:[animation-play-state:paused] flex items-center py-10 gap-10 px-10">
            {[client1, client2, client3, client4, client5, client6, client7, client8, client9].map((imgSrc, idx) => (
              <div key={idx} style={clientImage} className="flex-shrink-0 opacity-50 hover:opacity-100 transition-opacity duration-300">
                <img src={imgSrc} alt={`client-${idx + 1}`} className="h-full object-contain" />
              </div>
            ))}
            {[client1, client2, client3, client4, client5, client6, client7, client8, client9].map((imgSrc, idx) => (
              <div key={`repeat-${idx}`} style={clientImage} className="flex-shrink-0 opacity-50 hover:opacity-100 transition-opacity duration-300">
                <img src={imgSrc} alt={`client-repeat-${idx + 1}`} className="h-full object-contain" />
              </div>
            ))}
          </div>
        </div>
      </section>

      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll {
          animation: scroll 20s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default Clients;